export default __webpack_public_path__ + "static/media/404-1.822e8ec5.png";